import { ElementRef, OnChanges, AfterViewInit, SimpleChanges, Input } from '@angular/core';
import { Directive } from '@angular/core';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

declare var $;

@Directive({
  selector: '[basic-table]',
})
export class BasicTableDirective implements AfterViewInit, OnChanges{
	@Input() data;
  // observer: MutationObserver;
  dataChange = new Subject<any>();
  dataChangeSubscription: Subscription;

  constructor(
    private el: ElementRef
  ) {}

  ngAfterViewInit(): void {
    this.onChanges();
  	this.dataChangeSubscription = this.dataChange.asObservable().pipe(debounceTime(10)).subscribe(data => {
      this.onChanges();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
  	this.dataChange.next(changes);
  }


  onChanges() {
  	$(this.el.nativeElement).basictable('destroy');
    $(this.el.nativeElement).basictable({
      breakpoint: 1025,
    });
  }

  ngOnDestroy() {
    $(this.el.nativeElement).basictable('destroy');
    this.dataChangeSubscription.unsubscribe()
  }

}
